var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error && _vm.error.type === 'TOKEN_EXPIRED')?_c('LargeNotice',{attrs:{"icon":"😢","title":this.$t('error.title'),"subtitle":this.$t('error.expired-token')}}):_c('LargeNotice',{attrs:{"icon":"😢","title":this.$t('error.title'),"subtitle":this.$t('error.unknown-error')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }